import { File02Icon } from '@langchain/untitled-ui-icons';

import { Link } from 'react-router-dom';

import { IconButton } from '@/design-system';

export function DocsButton({
  link,
  className,
}: {
  link: string;
  className?: string;
}) {
  return (
    <Link to={link} target="_blank">
      <IconButton
        variant="plain"
        size="sm"
        color="secondary"
        className={className}
        icon={File02Icon}
        label="Documentation"
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Link>
  );
}
